import { LinkField } from '@prismicio/client';
import { SliceClass } from './slice.class';

export class MenuItem extends SliceClass {
  public title: string;
  public link: LinkField;
}

export class SimpleMenuItem extends MenuItem {}
